import { render, staticRenderFns } from "./ProblemReport.vue?vue&type=template&id=07c1e2c4"
import script from "./ProblemReport.vue?vue&type=script&lang=js"
export * from "./ProblemReport.vue?vue&type=script&lang=js"
import style0 from "./ProblemReport.vue?vue&type=style&index=0&id=07c1e2c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports